module.exports = __webpack_public_path__ + "img/editarFiltros.41e08ab0.svg";